import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack, RAD2DEG } from '../../utils/index.js';
var sqrt = Math.sqrt,
  atan2 = Math.atan2,
  round = Math.round;
var lab2lch = function lab2lch() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var _unpack = unpack(args, 'lab'),
    _unpack2 = _slicedToArray(_unpack, 3),
    l = _unpack2[0],
    a = _unpack2[1],
    b = _unpack2[2];
  var c = sqrt(a * a + b * b);
  var h = (atan2(b, a) * RAD2DEG + 360) % 360;
  if (round(c * 10000) === 0) h = Number.NaN;
  return [l, c, h];
};
export default lab2lch;